import React, { useEffect, useState } from "react";
import AlertModal from "../alertModal";
import { deleteRequest } from "../../core/delete";
import { usePostContext } from "../../contexts/postContext";
import { alertMessages } from "../alertMessages";

export default function PostDelete(props) {
  const [showAlert, setShowAlert] = useState(false);
  const [modalOptions, setModalOptions] = useState({});
  // eslint-disable-next-line
  const [deleteError, setDeleteError] = useState(false);

  const { registerPostDeleteFunction, setActiveGridItemActions } =
    usePostContext();
  const { postStartDelete, postDeleteConfirm } = alertMessages;

  useEffect(() => {
    registerPostDeleteFunction((value) => startDelete(value));
    // eslint-disable-next-line
  }, []);

  const deletePost = (id) => {
    const path = props.deletePath;
    if (path) {
      deleteRequest(`${path}/${id}?_format=json`, props.user.csrf_token)
        .then((response) => {
          setActiveGridItemActions({});
          setModalOptions({
            alertType: "warning",
            alertMessageTitle: postDeleteConfirm.title,
            alertMessageBody: postDeleteConfirm.message,
            confirmButton: true,
            confirmButtonLabel: "Confirm",
            onConfirm: () => {
              if (props.getContent) {
                props.getContent();
              }
            },
            showAlertCallback: () => {
              setShowAlert(false);
            },
          });
          setShowAlert(true);
        })
        .catch((_error) => {
          setDeleteError(true);
          setModalOptions({
            alertType: "error",
            alertMessageTitle: "Delete failed",
            alertMessageBody:
              "Something went wrong while deleting this item. Please try again.",
            confirmButton: true,
            confirmButtonLabel: "OK",
            showAlertCallback: () => {
              setShowAlert(false);
            },
          });
          setShowAlert(true);
        });
    }
  };

  const startDelete = (id) => {
    setModalOptions({
      alertType: "warning",
      alertMessageTitle: postStartDelete.title,
      alertMessageBody: postStartDelete.message,
      cancelButton: true,
      cancelButtonLabel: "Cancel",
      confirmButton: true,
      confirmButtonLabel: "Delete",
      confirmButtonColor: "error",
      onConfirm: () => {
        deletePost(id);
      },
      showAlertCallback: () => {
        setShowAlert(false);
      },
    });
    setShowAlert(true);
  };

  return (
    <AlertModal showAlert={showAlert} showCaLogo={true} {...modalOptions} />
  );
}
